import { formatDate } from '@/helper'

export default {
  getData (state) {
    return state.data.map((item) => {
      return {
        ...item,
        dateOfBirthFormatted: formatDate(item.dateOfBirth, 'onlyDate'),
        role: item.role.at(0)
      }
    })
  },
  getActiveUsers (state) {
    return state.data.filter(user => user.status === 'activated')
  }
}
